// extracted by mini-css-extract-plugin
export default {"card":"AuditData_card__d+qrr","auditQuestion":"AuditData_auditQuestion__nckPJ","photos":"AuditData_photos__yfcxX","photosDiv":"AuditData_photosDiv__jTmy-"};